import type { RoomsParticipantDistribution as RoomsParticipantDistributionType } from '@/domain/shared/types';

export const formatParticipantDistributionToGA4Result = (distribution: RoomsParticipantDistributionType) => {
  const adultsAmount = distribution.reduce((acc, room) => acc + room.adults, 0);
  const childrenAmount = distribution.reduce((acc, room) => acc + room.children.length, 0);
  const babiesAmount = distribution.reduce((acc, room) => acc + room.babies.length, 0);

  return {
    distribution: `${adultsAmount}a ${childrenAmount}c ${babiesAmount}b`,
    total: `${adultsAmount + childrenAmount + babiesAmount}`,
  };
};
